import { useState, SubmitEvent, SubmitEventHandler } from 'react'
import Link from 'next/link'
import paymentMethods from '@/data/paymentMethods'
import countries from '@/data/countries'
import Label from '@/components/common/Label'
import { className } from '@/components/common/styles'
import Panel from '@/components/common/Panel'
import { isIterableArray } from '@/lib/helpers'

// @@TODO: Split and restructure payment into creditcard, address
const PaymentMethod = () => {
  const [paymentMethod, setPaymentMethod] = useState('Netherlands')
  const [primary, setPrimary] = useState(true)
  const [creditcardNumber, setCreditcardNumber] = useState('542870308566')
  const [creditcardExpirationMonth, setCreditcardExpirationMonth] =
    useState('08')
  const [creditcardExpirationYear, setCreditcardExpirationYear] = useState('23')
  const [creditcardCVV, setCreditcardCVV] = useState('789')
  const [creditcardHolder, setCreditcardHolder] = useState('P. Paulusma')
  const [fullStreetAddress, setFullStreetAddress] = useState(
    't/o Jacob van Lennepkade 145bis',
  )
  const [city, setCity] = useState('Amsterdam')
  const [postalCode, setPostalCode] = useState('1053AB')
  const [provinceStateCounty, setProvinceStateCounty] =
    useState('North-Holland')
  const [country, setCountry] = useState('Netherlands')

  const handleAccountSettings: SubmitEventHandler = (
    e: SubmitEvent<HTMLInputElement>,
  ) => {
    e.preventDefault()
    console.log({
      paymentMethod,
      primary,
      creditcardNumber,
      creditcardExpirationMonth,
      creditcardExpirationYear,
      creditcardCVV,
      creditcardHolder,
      fullStreetAddress,
      city,
      postalCode,
      provinceStateCounty,
      country,
    })
  }

  return (
    <div className="p-4">
      <Panel title="Payment method">
        <form onSubmit={handleAccountSettings}>
          <div className="grid grid-cols-2 gap-x-8">
            <div className="col-span-2 md:col-span-1">
              <Label
                id="paymentmethod"
                label="Payment method"
                value={paymentMethod}
                type="select"
                populate={
                  isIterableArray(countries) &&
                  paymentMethods.map((country) => (
                    <option value={country} key={country}>
                      {country}
                    </option>
                  ))
                }
                onChange={({ target }) =>
                  setPaymentMethod((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2 md:col-span-1">
              <Label
                id="primary"
                label="Primary"
                value=""
                checked={primary}
                type="checkbox"
                onChange={() => setPrimary(!primary)}
              />
            </div>
            <div className="col-span-2">
              <Label
                id="creditcard-number"
                label="Card number (MasterCard)"
                value={creditcardNumber}
                placeholder="xxxx-xxxx-xxxx"
                onChange={({ target }) =>
                  setCreditcardNumber((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="grid grid-cols-3 gap-x-8 col-span-2">
              <div className="col-span-1 md:col-span-1">
                <Label
                  id="expiration-date-month"
                  label="Expiration date"
                  value={creditcardExpirationMonth}
                  placeholder="MM"
                  tooltip="This credit card has expired. Please update this credit card or delete it from payment methods."
                  icon="exclamation-triangle"
                  iconcolor="text-primary"
                  ttid="tt-creditcard-expiration"
                  onChange={({ target }) =>
                    setCreditcardExpirationMonth(
                      (target as HTMLInputElement).value,
                    )
                  }
                />
              </div>
              <div className="col-span-1 md:col-span-1">
                <Label
                  id="expiration-date-year"
                  label=""
                  value={creditcardExpirationYear}
                  placeholder="YY"
                  onChange={({ target }) =>
                    setCreditcardExpirationYear(
                      (target as HTMLInputElement).value,
                    )
                  }
                />
              </div>
              <div className="col-span-2 md:col-span-1">
                <Label
                  id="creditcard-cvv"
                  label="CVV"
                  value={creditcardCVV}
                  placeholder="xxx"
                  tooltip="CVV = Card Verification Value. CVV will only be used for verification. CVV will never be stored by us."
                  icon="info-circle"
                  iconcolor="text-primary"
                  ttid="tt-creditcard-cvv"
                  onChange={({ target }) =>
                    setCreditcardCVV((target as HTMLInputElement).value)
                  }
                />
              </div>
            </div>
            <div className="col-span-2">
              <Label
                id="creditcard-name"
                label="Name on card (holder)"
                value={creditcardHolder}
                onChange={({ target }) =>
                  setCreditcardHolder((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2">
              <Label
                id="full-street-address"
                label="Full street address"
                value={fullStreetAddress}
                onChange={({ target }) =>
                  setFullStreetAddress((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2 md:col-span-1">
              <Label
                id="city"
                label="City/Town"
                value={city}
                onChange={({ target }) =>
                  setCity((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2 md:col-span-1">
              <Label
                id="postal-code"
                label="ZIP/Postal code"
                value={postalCode}
                onChange={({ target }) =>
                  setPostalCode((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2">
              <Label
                id="province-state-county"
                label="State/Province/Territory/County"
                value={provinceStateCounty}
                onChange={({ target }) =>
                  setProvinceStateCounty((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2">
              <Label
                id="country"
                label="Country/Region"
                value={country}
                type="select"
                populate={
                  isIterableArray(countries) &&
                  countries.map((country) => (
                    <option value={country} key={country}>
                      {country}
                    </option>
                  ))
                }
                onChange={({ target }) =>
                  setCountry((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2 pb-4">
              <Link href="#!">
                <div className="text-blue-600 dark:text-blue-400 hover:underline decoration-2">
                  Read more about why we require this personal information
                </div>
              </Link>
            </div>
            <div className="col-span-2 pb-6">
              <button className={`${className} float-end`} type="submit">
                Update payment method
              </button>
            </div>
          </div>
        </form>
      </Panel>
    </div>
  )
}

export default PaymentMethod
